import { c as _c } from "react/compiler-runtime";
import React from "react";
export interface FixtureMetadataProps {
  componentName: string;
  sourcePath: string;
  domain: string;
  dependencies: Array<{
    path: string;
    description: string;
  }>;
  version?: string;
}
export const FixtureMetadata: React.FC<FixtureMetadataProps> = t0 => {
  const $ = _c(23);
  const {
    componentName,
    sourcePath,
    domain,
    dependencies,
    version: t1
  } = t0;
  const version = t1 === undefined ? "\u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F (\u0431\u0435\u0437 \u044F\u0432\u043D\u043E\u0439 \u0432\u0435\u0440\u0441\u0438\u043E\u043D\u043D\u043E\u0441\u0442\u0438)" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">Имя компонента</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== componentName) {
    t3 = <div className="flex flex-col gap-1">{t2}<span className="font-medium">{componentName}</span></div>;
    $[1] = componentName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">Путь к исходнику</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== sourcePath) {
    t5 = <div className="flex flex-col gap-1">{t4}<code className="rounded bg-background px-2 py-1 font-mono text-xs">{sourcePath}</code></div>;
    $[4] = sourcePath;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">Доменная область</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== domain) {
    t7 = <div className="flex flex-col gap-1">{t6}<code className="rounded bg-background px-2 py-1 font-mono text-xs">{domain}</code></div>;
    $[7] = domain;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">Ключевые зависимости</span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== dependencies) {
    t9 = dependencies.map(_temp);
    $[10] = dependencies;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t8}<div className="rounded bg-background px-2 py-1 font-mono text-xs"><ul className="ml-6 list-disc space-y-1">{t9}</ul></div></div>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-xs font-semibold tracking-wide text-muted-foreground uppercase">Версия</span>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== version) {
    t12 = <div className="flex flex-col gap-1">{t11}<code className="rounded bg-background px-2 py-1 font-mono text-xs">{version}</code></div>;
    $[15] = version;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t12 || $[19] !== t3 || $[20] !== t5 || $[21] !== t7) {
    t13 = <div className="space-y-3 rounded-md border bg-muted/20 p-4 text-sm md:text-base"><div className="grid gap-y-3">{t3}{t5}{t7}{t10}{t12}</div></div>;
    $[17] = t10;
    $[18] = t12;
    $[19] = t3;
    $[20] = t5;
    $[21] = t7;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
function _temp(dep, index) {
  return <li key={index}><code>{dep.path}</code> — {dep.description}</li>;
}